import { gql } from '@apollo/client'

export const ANONYMOUS_ZONE_FRAGMENT = gql`
  fragment AnonymousZone on AnonymousZone {
    id
    parentId
    name
  }
`
